import React from "react";

const NestedFrames = () => {
  const parentFrameContent = `
    <html>
      <body style="font-family: Arial; padding:20px;">
        <h3>Parent Frame</h3>
        <p>This is the parent iframe.</p>

        <iframe 
          srcdoc="<p style='text-align:center;'>Child Iframe</p>"
          width="200"
          height="200"
          id="frame2"
          name="frame2"
          style="border:1px solid #ccc;"
        ></iframe>

      </body>
    </html>
  `;

  return (
    <div className="col-md-8 col-lg-8 col-xl-8">
      <h1 className="mb-3 fw-normal border-bottom text-left pb-2 mb-4">
        Nested Frames
      </h1>

      <p>
        Sample Nested Iframe page. There are nested iframes in this page.
        You can switch between the parent frame and the nested child frame.
      </p>

      <iframe
        srcDoc={parentFrameContent}
        width="100%"
        height="400px"
        id="frame1"
        name="frame1"
        title="Parent Frame"
        style={{ border: "1px solid #ccc" }}
      ></iframe>
    </div>
  );
};

export default NestedFrames;